import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/fonts/Tajawal-Regular.ttf";
import "./index.css";

// ─── Suppress ResizeObserver loop errors (Ant Design + charts: Apex/Chart.js) ───────────────
// 1. Defer callbacks by two animation frames — breaks the "undelivered notifications" loop
//    more reliably than a single rAF when layout keeps mutating in the same tick.
if (window.ResizeObserver) {
  const _OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends _OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (!Array.isArray(entries) || !entries.length) return;
            callback(entries, observer);
          });
        });
      });
    }
  };
}

const isBenignResizeObserverMessage = (msg) => {
  if (!msg) return false;
  const s = String(msg);
  return (
    s.includes("ResizeObserver loop") ||
    s.includes("ResizeObserver loop limit exceeded") ||
    s.includes("undelivered notifications")
  );
};

// 2. Stop CRA dev overlay from treating this as a fatal runtime error.
window.addEventListener(
  "error",
  (e) => {
    if (
      isBenignResizeObserverMessage(e.message) ||
      isBenignResizeObserverMessage(e?.error?.message)
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (e) => {
    if (
      isBenignResizeObserverMessage(e?.reason?.message) ||
      isBenignResizeObserverMessage(e?.reason)
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true
);

const prevOnError = window.onerror;
window.onerror = function onErrorFilter(message, source, lineno, colno, error) {
  if (isBenignResizeObserverMessage(message) || isBenignResizeObserverMessage(error?.message)) {
    return true;
  }
  if (typeof prevOnError === "function") {
    return prevOnError.call(this, message, source, lineno, colno, error);
  }
  return false;
};
// ─────────────────────────────────────────────────────────────────────────────────────────────

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
